import * as types from '@/store/mutation-types'
export default {
    namespaced: true,
    state: {
        messages: []
    },

    actions: {
        fetchAll ({ commit }) {
            return window.coreAxios.get('/driverAssistant/quickMessages').then(({ data }) => {
                commit(types.STORE_MESSAGES, data.data)
                return data.data
            })
        },

        // new API only sends to one student (or the whole trip) per call - loop over the selected students
        sendMessage ({ commit }, { tripId, studentIds, messageTemplateId, customBody }) {
            return Promise.all(
                studentIds.map(studentId =>
                    window.coreAxios.post('/driverAssistant/notifications/sendMessage', {
                        tripId,
                        studentId,
                        messageTemplateId,
                        customBody
                    })
                )
            )
        }
    },

    mutations: {
        [types.STORE_MESSAGES] (state, messages) {
            state.messages = messages
        }
    },

    getters: {}
}
